export type Cls1SecurityDetail = {
  favoriteWork: FavoriteWork[]
  fixShiftDays: FixShift[]
  maxRepeatedly?: number
}

export type Cls2SecurityDetail = {
  email: string
  phoneNumber1: string
}

export const FAVORITE_WORK = {
  DAY_SHIFT: 1 << 0,
  NIGHT_SHIFT: 1 << 1,
} as const
export type FavoriteWork = (typeof FAVORITE_WORK)[keyof typeof FAVORITE_WORK]

export const FIX_SHIFT = {
  UNSELECT: 0,
  OK: 1,
  NG: 2,
} as const
export type FixShift = (typeof FIX_SHIFT)[keyof typeof FIX_SHIFT]
